var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "74.000000pt",
    height: "75.000000pt",
    viewBox: "0 0 74.000000 75.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,75.000000) scale(0.100000,-0.100000)",
    fill: "#a51713",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263 726 c-104 -34 -186 -106 -231 -205 -22 -47 -27 -70 -27 -146 0 -118 31 -191 116 -269 76 -70 147 -98 249 -98 110 0 179 29 256 106 144 144 149 355 13 510 -61 69 -150 109 -252 113 -51 2 -98 -2 -124 -11z m207 -75 c118 -45 194 -154 194 -281 0 -201 -201 -341 -397 -274 -60 20 -132 84 -162 145 -120 236 118 504 365 410z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 526 c-7 -8 -11 -25 -9 -38 2 -18 9 -23 32 -23 36 0 56 27 40 53 -14 22 -48 27 -63 8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 398 c-7 -7 -12 -41 -12 -89 0 -83 12 -106 50 -94 19 6 21 13 18 98 -3 83 -5 92 -23 95 -11 1 -26 -3 -33 -10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.7d9e196df33e2d845df314ef6c6a9835.svg";
export { ForwardRef as ReactComponent };